import { render, staticRenderFns } from "./EmasTersediaView.vue?vue&type=template&id=31897a6e&scoped=true&"
import script from "./EmasTersediaView.vue?vue&type=script&lang=js&"
export * from "./EmasTersediaView.vue?vue&type=script&lang=js&"
import style0 from "./EmasTersediaView.vue?vue&type=style&index=0&id=31897a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31897a6e",
  null
  
)

export default component.exports